import NestedList from '../nestedList';
import hatchedLogo from '../../images/logo/hatchedLogo.svg';
import settings from '../../images/sideBar/settings.svg';
import support from '../../images/sideBar/support.svg';
import { Avatar, Typography } from '@mui/material';
import IconBreadcrumbs from '../breadCrumbs';
import { useNavigate, useParams } from 'react-router';
import DashboardList from '../DashboardList';
import { memo, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import { AccountType } from 'src/pages/Auth/helpers/tokens';
import { useSettingsUpdatePersonal, useUserSettings } from 'src/hooks/settings';
import { LogoProvider } from 'src/contexts/companiesContext';

function SideBarWrapper(props: any) {
  const auth = useAuth();
  const { children } = props;
  const navigate = useNavigate();
  const params = useParams();
  const { logout, user } = useAuth();

  const { personal: data } = useSettingsUpdatePersonal();

  const [isSelected, setSelectedList] = useState('');

  return (
    <div
      className="flex flex-row w-full"
      style={{
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      <div
        className="relative flex-cloumn  justify-between w-[26%]  h-full border-r-2 lg:w-[20%] border-[#F1F2F4] xl:w-[13%] "
        style={{
          height: '100vh'
        }}
      >
        <div
          className=" h-[80%] pb-[200px] flex-cloumn  px-3   justify-between "
          style={{
            overflow: 'scroll'
          }}
        >
          <div className="flex px-3 mt-8 mb-6 justify-start items-end flex-row">
            <img className="w-8 mr-3 h-8" src={hatchedLogo} />
            <h1 className="text-4xl text-black">Hatched</h1>
          </div>
          <div>
            {auth.user.accountType === AccountType.Startup ? (
              <>
                <NestedList
                  isSelected={isSelected}
                  onReset={() => setSelectedList('')}
                />
              </>
            ) : auth.user.accountType ? (
              <LogoProvider>
                <DashboardList />
              </LogoProvider>
            ) : null}
          </div>
        </div>
        <div className="flex-cloumn bg-[white] cloumn h-[20%] justify-end px-3">
          <div style={{ flex: 1 }} className="h-[15%]" />
          <div
            onClick={() => {
              setSelectedList('settings');
              navigate('/settings');
            }}
            className={`flex flex-row my-3 py-2 items-center hover:bg-gray-50 rounded-lg px-4 gap-2 ${
              isSelected == 'settings' ? 'bg-gray-50 ' : ''
            } cursor-pointer`}
          >
            <img className="w-6 h-6" src={settings} alt={'settings'} />

            <Typography
              fontWeight={'600'}
              color="#344054"
              fontSize={16}
              className="bold  text-lg"
            >
              Settings
            </Typography>
          </div>
          <div className="h-0.5 bg-gray-50 cursor-pointer hover:bg-gray-50" />

          <div className="items-center justify-between pt-2">
            <Typography
              fontWeight={'600'}
              fontSize={14}
              className="Text text-slate-700 text-sm font-semibold  leading-tight"
            >
              {data?.firstName} {data?.lastName}
            </Typography>
            <div
              style={{
                justifyContent: 'space-between'
              }}
              className="flex flex-row  items-center  mr-2"
            >
              <Typography
                width={'70%'}
                textOverflow="ellipsis"
                whiteSpace={'nowrap'}
                overflow="hidden"
                fontWeight={'400'}
                fontSize={14}
                className="text-slate-600 text-sm font-normal  leading-tight"
              >
                {data?.email}
              </Typography>
              <svg
                onClick={() => {
                  logout();
                  navigate('/');
                }}
                xmlns="http://www.w3.org/2000/svg"
                width={36}
                height={36}
                fill="none"
                className="cursor-pointer"
              >
                <path
                  stroke="#667085"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.667}
                  d="M21.333 22.167 25.5 18m0 0-4.167-4.167M25.5 18h-10m0-7.5h-1c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 0 0-1.092 1.092C10.5 12.4 10.5 13.1 10.5 14.5v7c0 1.4 0 2.1.273 2.635a2.5 2.5 0 0 0 1.092 1.092c.535.273 1.235.273 2.635.273h1"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div
        className=" w-[75%] p-8 lg:w-[80%] xl:w-[90%]"
        style={{
          height: '100vh',
          overflow: 'scroll'
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default SideBarWrapper;
